/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type PatientRecordFieldsFragment = {
  __typename?: 'Patient'
  createdAt?: Date | null
  maritalStatus?: string | null
  racialIdentities?: Array<string> | null
  otherRacialIdentity?: string | null
  educationLevel?: string | null
  otherEducation?: string | null
  occupation?: string | null
  details?: Types.JSONObject | null
  billingID?: string | null
  credentialingHealthPlan?: string | null
  shippingAddress?: {
    __typename?: 'Address'
    street?: string | null
    city?: string | null
    state?: string | null
    zipCode?: string | null
  } | null
  emergencyContact?: { __typename?: 'EmergencyContact'; name?: string | null; phone?: string | null } | null
  primaryCareProvider?: {
    __typename?: 'PrimaryCareProvider'
    clinicName?: string | null
    physicianName?: string | null
    address?: string | null
    phone?: string | null
    website?: string | null
    consentGivenAt?: Date | null
    hasPrimaryCareProvider?: boolean | null
  } | null
  privateUserData: {
    __typename?: 'PrivateUserData'
    isFreeRider: boolean
    firstTimeLoginAt?: Date | null
    variables?: { __typename?: 'PrivateUserDataVariables'; hrvDevice?: string | null } | null
    consentDocuments: Array<{
      __typename?: 'ConsentDocument'
      id: string
      title: string
      acceptedAt?: Date | null
      acceptSource?: Types.AcceptSource | null
    }>
  }
}

export type GetAdvancedParticipantQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedParticipantQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    uid: string
    firstname?: string | null
    lastname?: string | null
    preferredName?: string | null
    genderIdentity?: string | null
    email?: string | null
    phone?: string | null
    timezone?: string | null
    language?: string | null
    birthDate?: Date | null
    stateOfResidence?: string | null
    createdAt?: Date | null
    maritalStatus?: string | null
    racialIdentities?: Array<string> | null
    otherRacialIdentity?: string | null
    educationLevel?: string | null
    otherEducation?: string | null
    occupation?: string | null
    details?: Types.JSONObject | null
    billingID?: string | null
    credentialingHealthPlan?: string | null
    enrollment: { __typename?: 'Enrollment'; id: string; programStartDate?: Date | null; state: Types.EnrollmentState }
    program?: { __typename?: 'Program'; id: string } | null
    shippingAddress?: {
      __typename?: 'Address'
      street?: string | null
      city?: string | null
      state?: string | null
      zipCode?: string | null
    } | null
    emergencyContact?: { __typename?: 'EmergencyContact'; name?: string | null; phone?: string | null } | null
    primaryCareProvider?: {
      __typename?: 'PrimaryCareProvider'
      clinicName?: string | null
      physicianName?: string | null
      address?: string | null
      phone?: string | null
      website?: string | null
      consentGivenAt?: Date | null
      hasPrimaryCareProvider?: boolean | null
    } | null
    privateUserData: {
      __typename?: 'PrivateUserData'
      isFreeRider: boolean
      firstTimeLoginAt?: Date | null
      variables?: { __typename?: 'PrivateUserDataVariables'; hrvDevice?: string | null } | null
      consentDocuments: Array<{
        __typename?: 'ConsentDocument'
        id: string
        title: string
        acceptedAt?: Date | null
        acceptSource?: Types.AcceptSource | null
      }>
    }
  }
}

export type UpdatePatientMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  patient?: Types.InputMaybe<Types.PatientInput>
  details?: Types.InputMaybe<Types.PatientDetailsInput>
  privateUserData?: Types.InputMaybe<Types.PrivateUserDataInput>
}>

export type UpdatePatientMutation = {
  __typename?: 'Mutation'
  updatePatient: {
    __typename?: 'Patient'
    uid: string
    firstname?: string | null
    lastname?: string | null
    preferredName?: string | null
    genderIdentity?: string | null
    email?: string | null
    phone?: string | null
    timezone?: string | null
    language?: string | null
    birthDate?: Date | null
    stateOfResidence?: string | null
    createdAt?: Date | null
    maritalStatus?: string | null
    racialIdentities?: Array<string> | null
    otherRacialIdentity?: string | null
    educationLevel?: string | null
    otherEducation?: string | null
    occupation?: string | null
    details?: Types.JSONObject | null
    billingID?: string | null
    credentialingHealthPlan?: string | null
    shippingAddress?: {
      __typename?: 'Address'
      street?: string | null
      city?: string | null
      state?: string | null
      zipCode?: string | null
    } | null
    emergencyContact?: { __typename?: 'EmergencyContact'; name?: string | null; phone?: string | null } | null
    primaryCareProvider?: {
      __typename?: 'PrimaryCareProvider'
      clinicName?: string | null
      physicianName?: string | null
      address?: string | null
      phone?: string | null
      website?: string | null
      consentGivenAt?: Date | null
      hasPrimaryCareProvider?: boolean | null
    } | null
    privateUserData: {
      __typename?: 'PrivateUserData'
      isFreeRider: boolean
      firstTimeLoginAt?: Date | null
      variables?: { __typename?: 'PrivateUserDataVariables'; hrvDevice?: string | null } | null
      consentDocuments: Array<{
        __typename?: 'ConsentDocument'
        id: string
        title: string
        acceptedAt?: Date | null
        acceptSource?: Types.AcceptSource | null
      }>
    }
  }
}

export type GetAdvancedSourcesQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetAdvancedSourcesQuery = { __typename?: 'Query'; sources: Array<{ __typename?: 'Source'; name: string }> }

export type GetAdvancedTodaysRecommendationQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  timezone: Types.Scalars['String']['input']
}>

export type GetAdvancedTodaysRecommendationQuery = {
  __typename?: 'Query'
  taskRecommendationsForPatient: {
    __typename?: 'TaskRecommendationsResult'
    taskRecommendations: Array<{
      __typename?: 'TaskRecommendation'
      taskID: string
      title?: string | null
      lessonID: string
      isDisabled: boolean
      completedAt?: Date | null
    }>
  }
}

export const PatientRecordFieldsFragmentDoc = gql`
  fragment PatientRecordFields on Patient {
    createdAt
    maritalStatus
    racialIdentities
    otherRacialIdentity
    educationLevel
    otherEducation
    occupation
    details
    billingID
    credentialingHealthPlan
    shippingAddress {
      street
      city
      state
      zipCode
    }
    emergencyContact {
      name
      phone
    }
    primaryCareProvider {
      clinicName
      physicianName
      address
      phone
      website
      consentGivenAt
      hasPrimaryCareProvider
    }
    privateUserData {
      isFreeRider
      firstTimeLoginAt
      variables {
        hrvDevice
      }
      consentDocuments {
        id
        title
        acceptedAt
        acceptSource
      }
    }
  }
`
export const GetAdvancedParticipantDocument = gql`
  query getAdvancedParticipant($uid: ID!) {
    patient(uid: $uid) {
      uid
      firstname
      lastname
      preferredName
      genderIdentity
      email
      phone
      timezone
      language
      birthDate
      stateOfResidence
      ...PatientRecordFields
      enrollment {
        id
        programStartDate
        state
      }
      program {
        id
      }
    }
  }
  ${PatientRecordFieldsFragmentDoc}
`

/**
 * __useGetAdvancedParticipantQuery__
 *
 * To run a query within a React component, call `useGetAdvancedParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedParticipantQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedParticipantQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedParticipantQuery, GetAdvancedParticipantQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedParticipantQuery, GetAdvancedParticipantQueryVariables>(
    GetAdvancedParticipantDocument,
    options
  )
}
export function useGetAdvancedParticipantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedParticipantQuery, GetAdvancedParticipantQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedParticipantQuery, GetAdvancedParticipantQueryVariables>(
    GetAdvancedParticipantDocument,
    options
  )
}
export type GetAdvancedParticipantQueryHookResult = ReturnType<typeof useGetAdvancedParticipantQuery>
export type GetAdvancedParticipantLazyQueryHookResult = ReturnType<typeof useGetAdvancedParticipantLazyQuery>
export type GetAdvancedParticipantQueryResult = Apollo.QueryResult<
  GetAdvancedParticipantQuery,
  GetAdvancedParticipantQueryVariables
>
export const UpdatePatientDocument = gql`
  mutation updatePatient(
    $uid: ID!
    $patient: PatientInput
    $details: PatientDetailsInput
    $privateUserData: PrivateUserDataInput
  ) {
    updatePatient(uid: $uid, patient: $patient, details: $details, privateUserData: $privateUserData) {
      uid
      firstname
      lastname
      preferredName
      genderIdentity
      email
      phone
      timezone
      language
      birthDate
      stateOfResidence
      ...PatientRecordFields
    }
  }
  ${PatientRecordFieldsFragmentDoc}
`
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      patient: // value for 'patient'
 *      details: // value for 'details'
 *      privateUserData: // value for 'privateUserData'
 *   },
 * });
 */
export function useUpdatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options)
}
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientMutation,
  UpdatePatientMutationVariables
>
export const GetAdvancedSourcesDocument = gql`
  query getAdvancedSources {
    sources {
      name
    }
  }
`

/**
 * __useGetAdvancedSourcesQuery__
 *
 * To run a query within a React component, call `useGetAdvancedSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvancedSourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAdvancedSourcesQuery, GetAdvancedSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedSourcesQuery, GetAdvancedSourcesQueryVariables>(GetAdvancedSourcesDocument, options)
}
export function useGetAdvancedSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedSourcesQuery, GetAdvancedSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedSourcesQuery, GetAdvancedSourcesQueryVariables>(
    GetAdvancedSourcesDocument,
    options
  )
}
export type GetAdvancedSourcesQueryHookResult = ReturnType<typeof useGetAdvancedSourcesQuery>
export type GetAdvancedSourcesLazyQueryHookResult = ReturnType<typeof useGetAdvancedSourcesLazyQuery>
export type GetAdvancedSourcesQueryResult = Apollo.QueryResult<
  GetAdvancedSourcesQuery,
  GetAdvancedSourcesQueryVariables
>
export const GetAdvancedTodaysRecommendationDocument = gql`
  query getAdvancedTodaysRecommendation($uid: ID!, $timezone: String!) {
    taskRecommendationsForPatient(uid: $uid, timezone: $timezone) {
      taskRecommendations {
        taskID
        title
        lessonID
        isDisabled
        completedAt
      }
    }
  }
`

/**
 * __useGetAdvancedTodaysRecommendationQuery__
 *
 * To run a query within a React component, call `useGetAdvancedTodaysRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedTodaysRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedTodaysRecommendationQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAdvancedTodaysRecommendationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedTodaysRecommendationQuery,
    GetAdvancedTodaysRecommendationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedTodaysRecommendationQuery, GetAdvancedTodaysRecommendationQueryVariables>(
    GetAdvancedTodaysRecommendationDocument,
    options
  )
}
export function useGetAdvancedTodaysRecommendationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedTodaysRecommendationQuery,
    GetAdvancedTodaysRecommendationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedTodaysRecommendationQuery, GetAdvancedTodaysRecommendationQueryVariables>(
    GetAdvancedTodaysRecommendationDocument,
    options
  )
}
export type GetAdvancedTodaysRecommendationQueryHookResult = ReturnType<typeof useGetAdvancedTodaysRecommendationQuery>
export type GetAdvancedTodaysRecommendationLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedTodaysRecommendationLazyQuery
>
export type GetAdvancedTodaysRecommendationQueryResult = Apollo.QueryResult<
  GetAdvancedTodaysRecommendationQuery,
  GetAdvancedTodaysRecommendationQueryVariables
>
